import React, { useEffect } from 'react';

import HiddenDiv from 'components/core/HiddenDiv.component';
import RELEASE from 'config/release.singleton';
import LSK from 'constants/core/localStorageKey.const';
import { fromAnyDateToIso, fromAnyDateToTimestamp } from 'utils/converters/time/from.util';
import { nowAsDate } from 'utils/date/now.util';
import lsGet from 'utils/dom/storage/lsGet.util';
import lsSet from 'utils/dom/storage/lsSet.util';
import { isEnvDev } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';

const L = logger('ReloadChecker');

const USE_FORCE = true;

const OFFSET = 60 * 1000;

const ReloadChecker = ({ tag, force, cutoff }) => {
  useEffect(
    () =>
      RELEASE.subscribe(async () => {
        const now = nowAsDate();

        const before = isFn(cutoff) ? cutoff(now) : false;
        const isUpToDate = await RELEASE.isUpToDate({ before });

        L.debug('()', 'isUpToDate:', isUpToDate, 'for tag:', tag, 'options:', { force, before, cutoff });

        if (isUpToDate) return;
        if (!force) return;

        if (isEnvDev()) {
          L.info('()', tag, 'Not reloading in development mode');
          return;
        }

        L.info('()', tag, 'New version is available, reloading browser page...');

        if (!USE_FORCE) return;

        const lastReload = lsGet(LSK.lastTimeCheckerReloaded);
        const isItTooSoon = OFFSET + fromAnyDateToTimestamp(lastReload) > fromAnyDateToTimestamp(now);

        if (isItTooSoon) {
          RELEASE.nextFull().then((full) => {
            const extra = { full, feNow: RELEASE.currNow(), feSha: RELEASE.currSha() };
            L.warn('()', tag, 'Not reloading because', 'extra info:', extra);
          });
          const info = { force, lastReload, before, isUpToDate, cutoff, nowDate: now, OFFSET };
          L.warn('()', tag, 'Not reloading because...', 'info:', info);
        } else {
          RELEASE.reload({ tag });
          lsSet(LSK.lastTimeCheckerReloaded, fromAnyDateToIso(now));
        }
      }),
    [cutoff, force, tag],
  );
  return <HiddenDiv tag="ReloadChecker" subtag={tag} />;
};

// noinspection JSUnusedGlobalSymbols
export default ReloadChecker;
